import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import UploadFilePopUp from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import React, { useState } from "react";
import DropDownList from "../../../../../ReusableComponents/DropDownList/DropDownList";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import Highlighter from "react-highlight-words";

export default function ListAjeerAppliedList({
  token,
  titles = [],
  list = [],
  callBack,
}) {
  var topTitles = [
    "S.NO.",
    "VISA PROVIDER",
    "CLIENT NAME",
    "EMPLOYEE COUNT",
    "SPONSOR ID 700",
    "AJEER STATUS",
  ];

  const [indexValue, setIndex] = useState(10);
  const [newCurrentList, setNewCurrentList] = useState([]);
  const [status, setStatus] = useState([]);
  const [ajeerStatus, SetAjeerStatus] = React.useState("");
  const [Popup, setPopUp] = useState(false);

  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();
  const [checkedItems, setCheckedItems] = useState({});

  console.log(".............eeweweeweweeew",newCurrentList)

  const [actionList, setActionList] = useState([]);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(newCurrentList || []);

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([employee_id, isChecked]) => isChecked)
      .map(([employee_id]) => employee_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      if (status === 3) {
        ajeerSentToClient({
          employee_id: Object.entries(checkedItems)
            .filter(([employee_id, isChecked]) => isChecked)
            .map(([employee_id]) => employee_id),
          ajeer_status:
            ajeerStatus === "REQUEST ACCEPTED BY CLIENT" ? "5" : "4",
        });
      } else {
        dispatch(
          setAppError({
            msg: "this employee already in process",
          })
        );
      }
    }
  };

  const handleCheckboxChange = (event, employee_id) => {
    const isChecked = event.target.checked;
    if (employee_id === "all") {
      const updatedCheckedItems = {};
      list.forEach((item) => {
        updatedCheckedItems[item.employee_id] = isChecked;
      });
      setCheckedItems(updatedCheckedItems);
    } else {
      setCheckedItems((prevState) => ({
        ...prevState,
        [employee_id]: isChecked,
      }));
    }
  };

  const updateValue = (event) => {
    console.log(event.target.value);
    SetAjeerStatus(event.target.value);
  };

  const ajeerSentToClient = async (type) => {
    try {
      const res = await nodeinstance.post("/ajeer/updateAjeerStatus/", type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("res", res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        apiCall();
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.error,
        })
      );
    }
  };

  const apiCall = () => {
    callBack();
  };

  return (
    <>
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 min-w-[1000px]">
            <div className="grid grid-cols-table-ajeer-applied gap-5 p-6 text-center">
              {topTitles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div>
            {list?.data.isLoading && (
              <LoadingWithLable className="col-span-6" />
            )}
            {list?.data.isLoading && <NoDataFound />}
            {!list?.data.isLoading
              ? list?.data?.listData.map((listData, index) => (
                <a
                  key={index}
                  onClick={() => {
                   
                    if (listData.ajeer_status_value === 3) {
                      setActionList([{ value: "REQUEST ACCEPTED BY CLIENT" }, { value: "REQUEST REJECTED" }])
                    } else {
                      setActionList([])
                    }
                    const filteredData = list?.data?.data.filter(
                      (indexData) =>
                        indexData.visa_provider === listData.visa_provider &&
                        indexData.client_name === listData.client_name &&
                        indexData.ajeer_status_value ===
                        listData.ajeer_status_value
                    );
                    setNewCurrentList(filteredData);
                    setIndex(index);
                    setStatus(listData.ajeer_status_value);
                    console.log(status);
                  }}
                  className={`grid grid-cols-table-ajeer-applied auto-cols-min gap-5 p-4 text-center ${indexValue === index ? "bg-orange-50" : "bg-white"} rounded-md `}
                  style={{ cursor: "pointer" }} // Apply pointer cursor style
                >
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.visa_provider || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.client_name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={
                          listData.employee_count.toString() || "-"
                        }
                      />
                    </p>
                    <p className="overflow-x-hidden">
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.sponsor_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.ajeer_status || "-"}
                      />
                    </p>
                    {/* {indexValue === index ? <></> : <hr
                    className={`border-[1px] border-slate-100  w-full col-span-full `}
                  />} */}
                  </React.Fragment>
                </a>
              ))
              : ""}
          </div>
        </div>
      </div>
      {currentList.length !== 0 ? (
        <>
          <div className=" flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => popOpen()}
            >
              <p>Update</p>
              {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
            </button>
            {Object.entries(checkedItems)
              .filter(([employee_id, isChecked]) => isChecked)
              .map(([employee_id]) => employee_id).length !== 0 ? (
              <DropDownList
                setValue={updateValue}
                presetValues={actionList}
              />
            ) : (
              <></>
            )}
            <Search
              searchKey={[
                "employee_id",
                "visa_reference_number",
                "border_number",
              ]}
              setSearchWords={setSearchWords}
            />
          </div>
          <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
          <CountPerPage />
          <div className="relative bg-white">
            <div className="overflow-x-auto max-h-[70vh] ">
              <div className="sticky top-0 z-10 bg-white min-w-[2550px]">
                <div className="grid grid-cols-table-ajeer-update gap-5 p-6 text-center">
                  {titles.map((t, index) => (
                    <p key={index} className="font-semibold uppercase">
                      {t == "ACTION" ? <div className="flex items-center mb-0  ">
                        <input
                          // disabled={list.ajeer_status_value.toString() === "2" || list.ajeer_status_value.toString() === "5" ? false : true}
                          key={list.employee_id}
                          type="checkbox"
                          checked={checkedItems[currentList.map((e) => (e.employee_id))] || false}
                          onChange={(event) => {
                            currentList.map((list) => (handleCheckboxChange(event, list.employee_id)));
                          }
                          }
                        />
                      </div> : t}
                    </p>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-table-ajeer-update gap-5 p-6 bg-white text-center">
                {list?.isLoading && (
                  <LoadingWithLable className="col-span-full" />
                )}
                {!list?.isLoading && <NoDataFound />}
                {!list?.isLoading &&
                  currentList.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>

                      <p className="overflow-x-hidden">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.client_name || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_provider || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.iqama_number || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_location_eng || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_location_ar || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_apply_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_issue_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_expiry_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_valid_days || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_status || "-"}
                        />
                      </p>
                      <div className="flex items-center mb-0  ">
                        <input
                          disabled={
                            list.ajeer_status === "Request Accepted By Client"
                              ? true
                              : false
                          }
                          key={list.employee_id}
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id)
                          }
                        />
                      </div>
                      <hr
                        className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>

          <Pagination />
        </>
      ) : (
        <></>
      )}
      {Popup ? (
        <UploadFilePopUp
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Border Number"}
          url={"/employees/updateBorderNumbersFromExcel"}
          callBack={apiCall}
        />
      ) : (
        ""
      )}
    </>
  );
}
